/**
 * User Roles and Permissions
 */

export type UserRole =
    | 'super_admin'
    | 'admin' // Business Owner
    | 'user'  // Regular Business User
    | 'support_admin'
    | 'support_l1'
    | 'support_l2'
    | 'billing_manager'
    | 'compliance_officer'
    | 'onboarding_specialist';

export const ROLES: Record<string, UserRole> = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    USER: 'user',
    SUPPORT_ADMIN: 'support_admin',
    SUPPORT_L1: 'support_l1',
    SUPPORT_L2: 'support_l2',
    BILLING_MANAGER: 'billing_manager',
    COMPLIANCE_OFFICER: 'compliance_officer',
    ONBOARDING_SPECIALIST: 'onboarding_specialist',
};

export const ROLE_LABELS: Record<UserRole, string> = {
    super_admin: 'Super Admin',
    admin: 'Business Admin',
    user: 'User',
    support_admin: 'Support Administrator',
    support_l1: 'L1 Support Agent',
    support_l2: 'L2 Support Agent',
    billing_manager: 'Billing Manager',
    compliance_officer: 'Compliance Officer',
    onboarding_specialist: 'Onboarding Specialist',
};

export const SUPPORT_ROLES: UserRole[] = [
    'support_admin',
    'support_l1',
    'support_l2',
    'billing_manager',
    'compliance_officer',
    'onboarding_specialist'
];
